import * as React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  sectionHeading: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    marginBottom: 10,
    fontSize: 36,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 29,
      display: "inline-block",
    },
    color: theme.palette.grey[800],
  },
});

const SectionHeader = (props) => {
  const { text, children, classes } = props;
  return (
    <Typography variant={"h4"} className={classes.sectionHeading}>
      {children || text}
    </Typography>
  );
};

SectionHeader.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(styles)(SectionHeader);



// WEBPACK FOOTER //
// ./src/components/UI/SectionHeader.jsx